module.exports = __webpack_public_path__ + "static/media/grin-wink.9b4f6665.svg";